<template>
  <div style="height: inherit">

    <b-table
      ref="refUserListTable"
      class="position-relative"
      :items="getDataTable"
      responsive
      :fields="fields"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="Không có dữ liệu"
      :sort-desc.sync="isSortDirDesc"
      table-class="vgt-table cs-table-info"
      style="min-height: 180px;"
    >
      <template #cell(STT)="data">
        <span style="font-size: 12px">{{
          data.index + (currentPage - 1) * perPage + 1
        }}</span>
      </template>
      <!-- Column: User -->
      <template #cell(fileName)="data">
        <span style="font-size: 12px">{{ data.item.fileName }}</span>
      </template>
      <template #cell()="row">
        <div class="demo-inline-spacing text-center">
          <b-button
            :href="`${urlFile}/files/downloadhuongdan/${row.item.id}`"
            variant="flat-success"
            class="btn-icon p-50 m-0"
            v-b-tooltip.hover.top="'Tải về'"
          >
            <feather-icon icon="DownloadCloudIcon" size="16" />
          </b-button>
        </div>
      </template>
    </b-table>


  </div>
</template>

<script>
/* eslint-disable */

import {
  BCardBody,
  BFormGroup,
  BFormSelect,
  VBTooltip,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
  BCardHeader,
} from "bootstrap-vue";
import { BOverlay } from "bootstrap-vue";
import LayoutData from "@/layouts/LayoutData";
import Ripple from "vue-ripple-directive";

import { ref, computed, watch } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";


import useSetup from "./useSetup";

import vueDropzone from "vue2-dropzone";

import {
  DeleteFileHuongDan,
} from "@/services/api/HoSoCanBoCongChuc/FileService";
export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    BOverlay,

    BCardBody,
    BFormGroup,
    BFormSelect,
    VBTooltip,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BCardHeader,
    vueDropzone,
  },
  data() {
    return {
      isWait: false,
      pageOptions: [20, 50, 100],
      nowFile: [],
      filesDelete: [],
      urlFile: process.env.VUE_APP_BASE_API,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_BASE_API}/files/uploadFileLocal`,
        thumbnailWidth: 300,
        // maxFiles: 1,
        maxFilesize: 30,
        headers: { "My-Awesome-Header": "header value" },
        acceptedFiles:
        " .pdf,  .PDF",
        //  " .docx, .doc,  .pdf,  .PDF",
        // addRemoveLinks: true,
        // previewTemplate: this.template(),
      },
    };
  },
  // computed: {
  //   common() {
  //     console.log("common", this.$store.state.common.common);
  //     return this.$store.state.common.common;
  //   },
  // },
  watch: {},
  methods: {
    sendingEvent(file, xhr, formData) {
      this.isWait = true;
        // formData.append('file', this.files)
      // formData.append("idCanBo", this.cbccvcDetail.id);
      // formData.append("index", importFileType("CongTac"));
      this.isWait = false;
    },
    UploadFile(file, response) {
      console.log("file", file);
      this.isWait = true;
      this.$refs.myVueDropzone.removeFile(file);
      if (response.code == "SUCCESS") {
        this.refetchData();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Thêm file thành công",
            icon: "CheckIcon",
            variant: "success",
            text: response.message,
          },
        });
        this.nowFile.push({
          fileId: response.data.id,
          fileName: response.data.fileName,
          ext: response.data.ext,
        });
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "error",
            text: response.message,
          },
        });
      }

      this.isWait = false;
    },

    deleteFile(data) {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.$bvModal
          .msgBoxConfirm("Xác nhận xoá", {
            okTitle: "Đồng ý",
            cancelTitle: "Hủy",
            cancelVariant: "outline-secondary",
          })
          .then((value) => {
            if (value) {
              this.isWait = true;
              DeleteFileHuongDan(data.id).then((res) => {
                console.log("HAHA",res);
                this.isWait = false;
                if (res.isError) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thất bại",
                      icon: "AlertTriangleIcon",
                      variant: "error",
                      text: res.message,
                    },
                  });
                } else {
                  this.refetchData();
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Xóa thành công",
                      icon: "CheckIcon",
                      variant: "success",
                      text: res.message,
                    },
                  });
                }
              });
            }
          });
      }
    },
   

  },
  created() {
  },
  setup(props, { emit }) {
    const toast = useToast();
    const { route, router } = useRouter();
    const headerData = ref(LayoutData.header.data);
    const appInfo = ref();
    headerData.value.title = "Cán bộ công chức";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;
    const totalRows = ref(0);
    const dataMeta = ref({});
    const {
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      isSortDirDesc,
      sortBy,
      refetchData,
      refUserListTable,

      fields,
      getDataTable,
    } = useSetup();



    const donViFilter = ref(null);
    const donVis = ref([]);
    const dataTableIsLoaded = ref(false);
    const dataTable = ref([]);
    const isShowLeftSidebar = ref(false);
    const editData = ref({
      donVi: {},
    });
    const tieuChis = ref(null);
    const fetchData = (filters) => {
      dataTableIsLoaded.value = true;
      tieuChis.value = filters;
      donViFilter.value = filters.donVi;
      // console.log("defaultDonVi", defaultDonVi);
      let condition = {
        donViId: donViFilter.value ? donViFilter.value.id : "",
        code: filters.code,
        isChildren: filters.isChildren ? filters.isChildren : false,
        trangThaiHoSoId: filters.trangThaiHoSo ? filters.trangThaiHoSo : null,
      };
      console.log("condition", condition);
      getDataList(condition, (res) => {
        dataTableIsLoaded.value = false;
        if (res != null){
          const blob = new Blob(
                  [base64ToArrayBuffer(res.fileContents)],
                  { type: "application/xlsx" }
              );
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              const fileName = res.fileDownloadName;
              link.download = fileName;
              link.click();
        }
        else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: "Lỗi khi tải file.",
            },
          });
        }
      });
    };

    const base64ToArrayBuffer = (base64) => {
      const binaryString = window.atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    };

    const showLeftSlidebar = (data, id) => {
      isShowLeftSidebar.value = true;
      if (!data.donVi) {
        data.donVi = null;
      }
      editData.value = JSON.parse(JSON.stringify(data));
      // }
    };




    const pagination = (value) => {
      currentPage.value = value;
    };

    const perpage = (value) => {
      perPage.value = value;
    };
    const sortby = (value) => {
      sortBy.value = value;
    };

    return {
      pagination,
      perpage,
      sortby,
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      dataTableIsLoaded,
      getDataTable,
      fields,
      refetchData,
      refUserListTable,

      totalRows,
      dataMeta,

      donVis,
      donViFilter,
      tieuChis,
      fetchData,
      dataTable,
      editData,

      isShowLeftSidebar,
      showLeftSlidebar,
      // reLoadDataTable,
      // removeItem,
      // fetchDanhMucData,
    };
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
#dropzone .dz-preview {
  width: 100%;
  display: none;
  margin: 10px;
  min-height: 0;
}
#dropzone {
  border: dashed 1px #056717 !important;
}
.dropzone .dz-message{
  text-align: center;
  margin: 2em 0;
}
#dropzone .dz-preview .dz-image-preview {
  background: none;
}

.input-with-clear {
  position: relative;
}

.clear-button {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
</style>
